/**
 * Main application entry point
 */

import AdvancedTooltip from "./03-objects/_advanced-tooltip";

import Select from "./04-forms/_select";

import Stepper from "./04-forms/_stepper";

import Password from "./04-forms/_password";

import FileUpload from "./04-forms/_file-upload";

import Accordion from "./05-components/_accordion";

import Dropdown from "./05-components/_dropdown";

import Notification from "./05-components/_notification";

import Table from "./05-components/_table";

import Sidebar from "./06-partials/_main-sidebar";

import Modal from "./06-partials/_modal";

let advancedTooltip = new AdvancedTooltip();
let select = new Select();
let stepper = new Stepper();
let password = new Password();
let fileUpload = new FileUpload();
let dropdown = new Dropdown();
let accordion = new Accordion();
let notification = new Notification();
let table = new Table();
let sidebar = new Sidebar();
let modal = new Modal();
